export enum BodyTypeValue {
  Convertible = 'convertible',
  Coupe = 'coupe',
  Crossover = 'crossover',
  Hatchback = 'hatchback',
  Minivan = 'minivan',
  Sedan = 'sedan',
  SUV = 'suv',
  Truck = 'truck',
  Wagon = 'wagon',
}

export const BodyTypeMessages: Record<BodyTypeValue, string> = {
  [BodyTypeValue.Convertible]: 'home.bodyStyle.Convertibles',
  [BodyTypeValue.Coupe]: 'home.bodyStyle.Coupes',
  [BodyTypeValue.Crossover]: 'home.bodyStyle.Crossover',
  [BodyTypeValue.Hatchback]: 'home.bodyStyle.Hatchbacks',
  [BodyTypeValue.Minivan]: 'home.bodyStyle.Minivans',
  [BodyTypeValue.Sedan]: 'home.bodyStyle.Sedans',
  [BodyTypeValue.SUV]: 'home.bodyStyle.SUVs',
  [BodyTypeValue.Truck]: 'home.bodyStyle.Trucks',
  [BodyTypeValue.Wagon]: 'home.bodyStyle.Wagons',
};
